import cn from 'classnames'
import { FC, ReactElement } from 'react'

import { Tweet } from 'components/ui/tweet'

import { ITweet } from 'components/ui/tweet/types'

import styles from './styles.module.scss'

export const Partner: FC<{
  logo: string
  logoWidth?: number
  logoHeight: number
  link: string
  linkAlt: string
  tweet?: ITweet
  description: ReactElement
  oneLineLessMargin?: boolean,
  followLink?: boolean
}> = ({ logo, logoWidth, logoHeight, link, oneLineLessMargin, linkAlt, tweet, description,followLink }) => {
  return (
    <div className={styles.container}>
      <div className={styles.partnerInfo}>
        <img
          className={styles.partnerIcon}
          src={logo}
          alt="PartnerLogo"
          width={logoWidth}
          height={logoHeight}
          loading="lazy"
        />
        <a 
          href={link} 
          target="_blank" 
          rel={followLink ? "noopener noreferrer" : "noopener noreferrer nofollow"}
        >
          {linkAlt}
        </a>
      </div>
      <div className={cn(styles.description, { [styles.oneLineLessMargin]: oneLineLessMargin })}>{description}</div>
      {tweet && (
        <div>
          <Tweet tweet={tweet} />
        </div>
      )}
    </div>
  )
}
